import './NavigationPanel.css';

import mainIcon from './../../image/main-nav.svg';
import contactIcon from './../../image/contact-nav.svg';
import userIcon from './../../image/user-nav.svg';
import paidIcon from './../../image/paid-nav.svg';
import bonusIcon from './../../image/bonus-nav.svg';

import mainIconActive from './../../image/main-nav-active.svg';
import contactIconActive from './../../image/contact-nav-active.svg';
import userIconActive from './../../image/user-nav-active.svg';
import paidIconActive from './../../image/paid-nav-active.svg';
import bonusIconActive from './../../image/bonus-nav-active.svg';

const NavigationPanel = ({
    setCurrentPage,
    currentPage,
    isButtonActive,
    setIsShowProductCard,
}) => {
    const handleMainClick = () => {
        setCurrentPage('MainPage');
        setIsShowProductCard(false);
    };

    const handleContactClick = () => {
        setCurrentPage('ContactPage');
        setIsShowProductCard(false);
    };

    const handleUserClick = () => {
        setCurrentPage('UserPage');
        setIsShowProductCard(false);
    };

    const handlePaidClick = () => {
        setCurrentPage('PaidPage');
        setIsShowProductCard(false);
    };

    const handleBonusClick = () => {
        setCurrentPage('BonusPage');
        setIsShowProductCard(false);
    };

    return (
        <div className='navigation__wrapper'>
            <div className='navigation__items'>
                <div
                    onClick={handleMainClick}
                    className={`navigation__item ${
                        currentPage === 'MainPage' ||
                        currentPage === 'MenuPage' ||
                        currentPage === 'ProductPage' ||
                        currentPage === 'CartPage'
                            ? 'active'
                            : ''
                    }`}
                >
                    <img
                        src={
                            currentPage === 'MainPage' ||
                            currentPage === 'MenuPage' ||
                            currentPage === 'ProductPage' ||
                            currentPage === 'CartPage'
                                ? mainIconActive
                                : mainIcon
                        }
                    />

                    <p>Главная</p>
                </div>

                <div
                    className={`navigation__item ${
                        currentPage === 'ContactPage' ||
                        currentPage === 'InfoPage'
                            ? 'active'
                            : ''
                    }`}
                    onClick={handleContactClick}
                >
                    <img
                        src={
                            currentPage === 'ContactPage' ||
                            currentPage === 'InfoPage'
                                ? contactIconActive
                                : contactIcon
                        }
                    />
                    <p>Контакты</p>
                </div>

                <div
                    className={`navigation__item ${
                        currentPage === 'UserPage' ? 'active' : ''
                    }`}
                    onClick={handleUserClick}
                >
                    <img
                        src={
                            currentPage === 'UserPage'
                                ? userIconActive
                                : userIcon
                        }
                    />
                    <p>Профиль</p>
                </div>

                <div
                    className={`navigation__item ${
                        currentPage === 'PaidPage' ||
                        currentPage === 'PaidMethodPage'
                            ? 'active'
                            : ''
                    }`}
                    onClick={handlePaidClick}
                >
                    <img
                        src={
                            currentPage === 'PaidPage' ||
                            currentPage === 'PaidMethodPage'
                                ? paidIconActive
                                : paidIcon
                        }
                    />
                    <p>Заказ</p>
                </div>

                {/* <div
                    className={`navigation__item ${
                        currentPage === 'BonusPage' ? 'active' : ''
                    }`}
                    onClick={handleBonusClick}
                >
                    <img
                        src={
                            currentPage === 'BonusPage'
                                ? bonusIconActive
                                : bonusIcon
                        }
                    />
                    <p>Бонусы</p>
                </div> */}
            </div>
        </div>
    );
};

export default NavigationPanel;
